const LOCALE_KEY = 'how2spanish-locale';

export const storeLocale = (locale) => {
    localStorage.setItem(LOCALE_KEY, locale);
}

export const getLocale = () => {
    return localStorage.getItem(LOCALE_KEY);
}
